import React from 'react'
import api from 'src/services/api'

const useLicenses = () => {

    const [loading, setLoading] = React.useState(false)
    const [data, setData] = React.useState<any[]>([])
    const [error, setError] = React.useState<string | null>(null)

    const fetch =  async (cb?:Function) => {
        setLoading(true)
        setError(null)
        try {
            const response = await api.get('/licenses')
            setData(response.data.licenseList)
            if(cb) cb(response.data.licenseList)
        } catch (err: any) {
            setError(err.message || 'Error fetching licenses')
        } finally {
            setLoading(false)
        }
    }



    return { loading, data, error, fetch }

}

export default useLicenses